import { useEffect, useMemo, useState } from 'react';

import {
  Box,
  Button,
  makeStyles,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@material-ui/core';
import UpcommingInbodyRow from '../../Rows/UpcommingInbody/UpcommingInbodyRow.component';

const ROWS_PER_PAGE = 10;

const useStyles = makeStyles(theme => ({
  cellHeader: {
    fontFamily: theme.typography.h1.fontFamily,
    fontWeight: theme.typography.h1.fontWeight,
    backgroundColor: 'black',
    color: 'white',
  },
  action: {
    padding: theme.spacing(1),
    color: theme.palette.action.main,
  },
  actionsCell: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  pagination: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
    padding: theme.spacing(2),
  },
  pageButton: {
    minWidth: 40,
  },
}));

const UpcommingInbodiesTable = ({ upcommingInbodies = [] }) => {
  const classes = useStyles();
  const [currentPage, setCurrentPage] = useState(1);

  const totalPages = Math.max(
    1,
    Math.ceil(upcommingInbodies.length / ROWS_PER_PAGE),
  );

  useEffect(() => {
    if (currentPage > totalPages) {
      setCurrentPage(totalPages);
    }
  }, [currentPage, totalPages]);

  const paginatedInbodies = useMemo(() => {
    const startIndex = (currentPage - 1) * ROWS_PER_PAGE;

    return upcommingInbodies.slice(startIndex, startIndex + ROWS_PER_PAGE);
  }, [currentPage, upcommingInbodies]);

  const onPreviousPageHandler = () => {
    setCurrentPage(page => Math.max(1, page - 1));
  };

  const onNextPageHandler = () => {
    setCurrentPage(page => Math.min(totalPages, page + 1));
  };

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell align="center" className={classes.cellHeader}>
              Tipo de cliente
            </TableCell>
            <TableCell align="center" className={classes.cellHeader}>
              Nombre
            </TableCell>
            <TableCell align="center" className={classes.cellHeader}>
              Celular
            </TableCell>
            <TableCell align="center" className={classes.cellHeader}>
              Partner - Colonia
            </TableCell>
            <TableCell align="center" className={classes.cellHeader}>
              Nutriólogo
            </TableCell>
            <TableCell align="center" className={classes.cellHeader}>
              Horario
            </TableCell>
            <TableCell align="center" className={classes.cellHeader}>
              Acciones
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {paginatedInbodies.map(item => (
            <UpcommingInbodyRow key={item.id} inbody={item} />
          ))}
        </TableBody>
      </Table>
      <Box className={classes.pagination}>
        <Button
          disabled={currentPage === 1}
          onClick={onPreviousPageHandler}
          variant="outlined"
        >
          Anterior
        </Button>
        {Array.from({ length: totalPages }, (_, index) => {
          const page = index + 1;

          return (
            <Button
              className={classes.pageButton}
              color={currentPage === page ? 'primary' : 'default'}
              key={page}
              onClick={() => setCurrentPage(page)}
              variant={currentPage === page ? 'contained' : 'outlined'}
            >
              {page}
            </Button>
          );
        })}
        <Button
          disabled={currentPage === totalPages}
          onClick={onNextPageHandler}
          variant="outlined"
        >
          Siguiente
        </Button>
      </Box>
    </TableContainer>
  );
};

export default UpcommingInbodiesTable;
